import React from 'react';
import { Route, Switch } from 'react-router';
import { adminRoutes } from './constants';

export const AdminRoutes = () => {

  return (
		<Switch>
			{
				[adminRoutes.map((route, index) => {
					return (
						<Route 
							key={index}
							path={route.path}
							exact={route.exact}
							render={() => <route.component />} />													
					)
					})					
				]
			}
		</Switch>
	);
}
